module.exports = __webpack_public_path__ + "img/leaf1.3df379b7.png";